import React, { Component, Fragment } from 'react';
import ReactPlayer from 'react-player';

export default class Profile extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>  
                <div className="container mt-5 bg">
                    <h1>Profil</h1>
                    <p>
                        Berdiri pada tahun 2015, PT. Sinergi Karya Sejahtera (PT. SKS) adalah perusahaan yang bergerak di bidang mechanical/electrical, khususnya dalam bidang tata udara (Air Conditioning System). Dengan support rekanan dari supplier dan principle company kami, mampu membuat PT. Sinergi Karya Sejahtera berkembang menjadi salah satu perusahaan kontraktor mechanical / electrical yang terbaik di Indonesia.
                    </p>
                    <p>
                        Selain itu, PT. Sinergi Karya Sejahtera juga mendapatkan dukungan penuh dari beberapa principle - principle khususnya di bidang tata udara, yang diberikan dalam bentuk sertifikasi resmi. Dukungan tersebut adalah dukungan technical, product knowledge, design/system, supervision, dan maintenance. Kami juga mendapatkan pelatihan-pelatihan secara berkala dari principle demi meningkatkan kompetensi Kami dalam memberikan layanan.
                    </p>
                    <p>
                        Selama ini, PT. Sinergi Karya Sejahtera telah menangani beberapa proyek baik dengan swasta maupun BUMN. Tipe proyek yang telah Kami tangani adalah gedung perkantoran, apartemen, sekolahan/universitas, rumah sakit, pabrik, mall, hotel, tempat ibadah dan bandara. Di setiap proyek yang Kami kerjakan, PT. Sinergi Karya Sejahtera selalu memberikan komitmen terbaik kepada pelanggan. Komitmen tersebut adalah dalam segi biaya, kualitas, waktu, dan pelayanan. Selain itu, Kami juga terus mengembangkan keahlian sumber daya Kami agar dapat selalu memberikan layanan yang lebih baik kepada pelanggan Kami dan dapat bersaing di pasar.
                    </p>
                    <h1>Visi</h1>
                    <p>
                        Menjadi perusahaan swasta nasional yang bergerak di bidang mechanical/ electrical di Indonesia yang selalu professional, terpercaya, serta memberikan pelayanan dan solusi yang terbaik.
                    </p>
                    <h1>Misi</h1>
                    <ul className="pl-3 pb-5">
                        <li>
                            Perusahaan yang berkomitmen tinggi menghasilkan kualitas kerja yang baik, serta memberikan pelayanan yang memuaskan.
                        </li>
                        <li>
                            Menjalin ikatan yang baik dengan klien dan partner bisnis.
                        </li>
                        <li>
                            Menciptakan sistem dan standar yang berkualitas dalam pelayanan.
                        </li>
                    </ul>
                    <h1>Nilai - Nilai Perusahaan</h1>
                    <ul className="pl-3 pb-5">
                        <li>
                            <h4>Profesional</h4>
                            <p>
                                Perusahaan swasta nasional yang bergerak di bidang mechanical/electrical khususnya di tata udara (Air Conditioning System) di Indonesia yang selalu profesional, terpercaya, serta memberika pelayanan dan solusi terbaik.
                            </p>
                        </li>
                        <li>
                            <h4>Terpercaya</h4>
                            <p>
                                Perusahaan yang berkomitmen tinggi menghasilkan kualitas kerja yang baik, serta memberikan pelayanan yang memuaskan.
                            </p>
                        </li>
                        <li>
                            <h4>Menyediakan Solusi</h4>
                            <p>
                                Menawarkan keahlian sebagai salah satu kontraktor tata udara yang terbaik di bidangnya.
                            </p>
                        </li>
                        <li>
                            <h4>Melayani Sepenuh Hati</h4>
                            <p>
                                Menciptakan sistem dan standar yang berkualitas dalam pelayanan.
                            </p>
                        </li>
                    </ul>
                </div>
            </Fragment>
        );
    }

}